import {
	createThoughtByUserIdApiV1UsersUserIdThoughtsPost,
	deleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDelete,
	getUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGet,
	getUserThoughtsByIdApiV1UsersUserIdThoughtsGet,
	markThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPost,
	recordDiaryPageVisitApiV1AnalyticsPageVisitsDiaryPost,
	updateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPut,
} from "@/shared/api/generated-backend"
import { captureError } from "@/shared/lib/diagnostics"
import type { CreateThoughtRequest, UpdateThoughtRequest } from "../model/types"

export async function getThoughts(userId: number) {
	return getUserThoughtsByIdApiV1UsersUserIdThoughtsGet({
		path: { user_id: userId },
	})
}

export async function getThought(userId: number, thoughtId: number) {
	return getUserThoughtByUserAndIdApiV1UsersUserIdThoughtsThoughtIdGet({
		path: { user_id: userId, thought_id: thoughtId },
	})
}

export async function createThought(
	userId: number,
	body: CreateThoughtRequest,
) {
	return createThoughtByUserIdApiV1UsersUserIdThoughtsPost({
		path: { user_id: userId },
		body,
	})
}

export async function updateThought(
	userId: number,
	thoughtId: number,
	body: UpdateThoughtRequest,
) {
	return updateThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdPut({
		path: { user_id: userId, thought_id: thoughtId },
		body,
	})
}

export async function markThoughtRead(userId: number, thoughtId: number) {
	return markThoughtAsReadAliasApiV1UsersUserIdThoughtsThoughtIdMarkReadPost({
		path: { user_id: userId, thought_id: thoughtId },
	})
}

export async function deleteThought(userId: number, thoughtId: number) {
	return deleteThoughtByUserIdApiV1UsersUserIdThoughtsThoughtIdDelete({
		path: { user_id: userId, thought_id: thoughtId },
	})
}

export function recordDiaryPageVisit(): void {
	recordDiaryPageVisitApiV1AnalyticsPageVisitsDiaryPost().catch((error) =>
		captureError(error, { scope: "thoughts.diaryPageVisit" }),
	)
}
